import client from '../../../client'

export default {
  DetailUpdate: param => {
    return new Promise((resolve, reject) => {

      var url = '/api/MasterWTMZNDetail/MasterWTMZNDetailUpdate'

      var qs = require('qs')
      var data = qs.stringify({

        'ircd': param.ircd,
        'tmzn': param.tmzn,
        'znnm': param.znnm,
        'sthh': param.sthh,
        'stmm': param.stmm

      })

      var config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + param.token,
        },
        data: data
      };

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/Admin/Master/WTMZN/WTMZNDetailUpdateApi.js